export enum DetritusType {
    Aluminium,
    PET,
    Glass,
    Paper,
    Household,
    Battery,
    Wood
}